import ChangePasswordSection from "@/pages/profile/ChangePasswordSection";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const AccountPasswordPane: FC = () => {
  const {t} = useTranslation(["common", "settings"]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <span className="text-neutral-black text-lg leading-none font-bold">{t("Change password")}</span>
        <span className="text-neutral-grey-dark text-xs">{t("settings:change_password_description")}</span>
      </div>
      <ChangePasswordSection variant="inline" />
    </div>
  );
};

export default AccountPasswordPane;
